import { sdk } from 'src/utilities/sdk';

export const getDeleteReportUrl = (corpId: string, exportId: string): string =>
  `/targetedaudiencesgateway/reporting/${corpId}/report/${exportId}`;

export async function deleteReportAPI(
  corpId: string,
  exportId: string
): Promise<void> {
  return sdk.http.delete(getDeleteReportUrl(corpId, exportId));
}
